import {
	IonBadge,
	IonButton,
	IonButtons,
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardSubtitle,
	IonCardTitle,
	IonCol,
	IonGrid,
	IonItem,
	IonRow,
	IonToolbar,
} from "@ionic/react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";

interface props {
	user: any;
	users: any;
}

const UserCard: React.FC<props> = ({ users, user }) => {
	const history = useHistory();

	const { displayName, lead, study, currentPhase, id } = user;

	const getLeadDisplayName = (id: any) => {
		let res = users[id];
		if (res) return res.displayName;
		return "";
	};

	const getStudyString = (str: any) => {
		switch (str) {
			case "eat":
				return "EAT";
				break;
			case "sleep":
				return "SLEEP";
				break;
			case "toilet":
				return "TOILET";
				break;

			default:
				break;
		}
	};

	return (
		<IonCard>
			<IonCardHeader>
				<IonItem lines="none">
					<IonGrid>
						<IonRow>
							<IonCol>
								<IonCardTitle>{displayName}</IonCardTitle>
							</IonCol>
						</IonRow>
						<IonRow>
							<IonCol>
								<IonCardSubtitle>
									{!user.isAdmin && <>Lead: {getLeadDisplayName(lead)}</>}
								</IonCardSubtitle>
							</IonCol>
						</IonRow>
					</IonGrid>
					{!user.isAdmin && (
						<IonBadge slot="end">{getStudyString(study)}</IonBadge>
					)}
					{user.isAdmin && (
						<IonBadge color="warning" slot="end">
							ADMIN
						</IonBadge>
					)}
				</IonItem>
			</IonCardHeader>
			<IonRow>
				<IonCol sizeSm="11" size="12">
					<IonButtons>
						<IonButton onClick={() => history.push(`/users/${id}/config`)}>
							Config
						</IonButton>
						{!user.isAdmin && (
							<>
								<IonButton onClick={() => history.push(`/users/${id}`)}>
									View
								</IonButton>
								<IonButton onClick={() => history.push(`/users/${id}/charts`)}>
									Charts
								</IonButton>
							</>
						)}
					</IonButtons>
				</IonCol>
			</IonRow>
		</IonCard>
	);
};

const mapStateToProps = (state: any) => ({
	users: state.user.users,
});

export default connect(mapStateToProps, {})(UserCard);
